import styled from "styled-components"
import CopyrightIcon from '@mui/icons-material/Copyright';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube'; 
import { ExtraSmall,Small } from "../Responsive";
//Styled Components
const Container=styled.div`
//  background-color: yellow;
 color: #364964;
 height: 35vh;
 margin: 50px auto;
 width: 90vw;
 ${ExtraSmall({height:"50vh"})}
`
const FooterContainer=styled.div`
// background-color: green;
display: flex;
height: inherit;
width: 100%;
`
const Headers=styled.h3`
font-weight: 500;
${ExtraSmall({fontSize:"18px"})}
${Small({fontSize:"18px"})}

`
const Address=styled.address`
font-size: 16px;
font-style: normal;
font-weight: 300;
line-height: 1.5;
${ExtraSmall({fontSize:"12px"})}
${Small({fontSize:"12px"})}
`
const AddressContainer=styled.div`
//  background-color: pink;
 display: flex;
 height: inherit;
 width: 70%;
 ${ExtraSmall({flexDirection:"column",gap:"1px",width: "60%"})}
`
const BranchAddress=styled.div`
// background-color: #000;
// color: #364964;
display: flex;
flex-direction: column;
justify-content:center;
gap: 20px;
height: inherit;
padding: 50px;
width: 50%;
${ExtraSmall({width:"100%",padding:"5px 20px",gap:"10px",height:"30vh"})}
`
const MainAddress=styled.div`
// background-color:white;
display: flex;
flex-direction: column;
justify-content:center;
gap: 20px;
height: inherit;
padding: 50px;
width: 50%;
${ExtraSmall({width:"100%",padding:"5px 20px",gap:"10px",height:"30vh"})}
${Small({padding:"5px 20px"})}
`
const Title=styled.div`
// background-color: orange;
display: flex;
align-items:center;
justify-content:center;
height: inherit;
width: 30%;
${ExtraSmall({width:"100%"})}
`
const DMWSTitle=styled.h1`
font-size: 31px;
font-style: normal;
font-weight: 300;
line-height: 1.4;
${ExtraSmall({fontSize:'28px',lineHeight:'2.5rem'})}
`
const CopySocial=styled.div`
//  background-color: red;
 display: flex;
 font-size: 13px;
 height: 7vh;
 margin-bottom:1vh;
 width: 100%;
`
const CopyRight=styled.div`
//  background-color: green;
 display: flex;
 align-items:Center;
 margin-left:2.7rem;
 height: inherit;
 width: 70%;
 ${ExtraSmall({marginLeft:"1rem",width:"50%"})}
`
const SocialIconConatiner=styled.div`
// background-color: yellow;
display:flex;
align-items:Center;
justify-content:center;
gap: 30px;
height: inherit;
width: 30%;
${ExtraSmall({width:"50%"})}
`
const Footer=()=>{
    return(
        <>
        <Container>
            <FooterContainer>
                <AddressContainer>
                    <BranchAddress>
                     <Headers>Branch Office</Headers>
                     <Address>Kleark Panchashil Buddha Vihar, Aurangabad, Maharashtra. - 431001.<br/>+91-8830337538</Address>
                    </BranchAddress>
                    <MainAddress>
                        <Headers>Main Office</Headers>
                        <Address>Dhamma Sagar Buddha Vihar,Tathagat Colony,CIDCO N-2 Vitthal Nagar, Ram Nagar Aurangabad,Maharashtra. 431001.<br/>
+91-7020504930</Address>
                    </MainAddress>
                </AddressContainer>
                <Title>
                    <DMWSTitle>
                        DHAMMA<br/>
                        METTA<br/>
                        WELFARE<br/>
                        SOCIETY
                    </DMWSTitle>
                </Title>
            </FooterContainer>
            <CopySocial>
                <CopyRight>
                    <CopyrightIcon style={{fontSize:"15px",marginRight:"10px"}}></CopyrightIcon>
                    All Rights Reserved
                </CopyRight>
                <SocialIconConatiner>
                    <FacebookIcon style={{fontSize:"15px"}}></FacebookIcon>
                    <InstagramIcon style={{fontSize:"15px"}}></InstagramIcon>
                    <YouTubeIcon style={{fontSize:"15px"}}></YouTubeIcon>
                </SocialIconConatiner>
            </CopySocial>
        </Container>
        </>
    )
}
export default Footer